import { useEffect, useState } from 'react';
const getInitialBreakpointValue = () => {
    // get initial breakpoint is called before the page is fully loaded and innerWith may be 0. windows.mqObj may not be set
    const mediaQueries = window.mqObj;
    const documentWidth = window.innerWidth;
    if (documentWidth == 0 || !mediaQueries) {
        return;
    }
    const filtered = Object.keys(mediaQueries).filter((key) => mediaQueries[key] <= documentWidth);
    const initalBr = filtered.length ? mediaQueries[filtered[filtered.length - 1]] : mediaQueries['xs'];
    return initalBr;
};
const mediaQueries = Object.assign({ '<xs': 0 }, window.mqObj);
const useBreakpoint = () => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState(getInitialBreakpointValue());
    const getCurrentBreakpoint = () => {
        const documentWidth = window.innerWidth;
        if (documentWidth == 0) {
            return;
        }
        const filtered = Object.keys(mediaQueries).filter((key) => mediaQueries[key] <= documentWidth);
        return mediaQueries[filtered[filtered.length - 1]];
    };
    const handleResize = () => {
        const currentBr = getCurrentBreakpoint();
        if (currentBr && currentBr !== currentBreakpoint) {
            // console.info('%c[React - Breakpoint change] ', 'color: green;font-weight: bold;', currentBr);
            setCurrentBreakpoint(currentBr);
        }
    };
    // const debounceResize = () => {
    //   handleResize();
    // };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    return currentBreakpoint;
};
export default useBreakpoint;
